import { createStrings } from '@utils/local';

export const secureDataStrings = createStrings({
  ja: {
    errorCancelled:
      'この書類の送信はキャンセルされました。この度は、大変ご迷惑をおかけ致しまして、申し訳ございませんでした。',
    errorOutdated: 'この書類の最新バージョンは別途メールにて送信いたしました。ご確認お願いします。',
  },
});
